import {store} from '../utilities'
import {auth} from  '../../Auth'

export default async function get(url, body) {
  const state = store.getState()

  const {customQuery} = state.tableVars.tableStrategy || {}

  if (customQuery) {
    const res = await customQuery(body)
    console.log(res)
    return res
  }

  const token = await auth.getToken(); 
  const headers = { 
    'Content-Type': `application/json` 
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await (
    await fetch(url, {
      method: `POST`,
      mode: `cors`,
      headers,
      body: JSON.stringify(body),
    })
  ).json()

  return res
}
